<template>
  <div>
    <form :action="permalink" method="post" enctype="multipart/form-data" v-on:submit.prevent="addToCart"
      class="add-to-cart-form" v-if="stockStatus == 'instock' && !isRentable" data-html2canvas-ignore="">
      <WellsAddToCart v-if="type === 'wells'" :id="id" :productTitle="name + ' - ' + sku" :minQuantity="getMinPurchaseQuantity(minQuantity, maxQuantity)"
        :maxQuantity="getMaxPurchaseQuantity(maxQuantity)" :isLoading="isLoading" :measurementUnit="measurementUnit"
        :buyingStep="buyingStep" :addToCartColor="getAddToCartColor()" ref="add_to_cart" @packageChanged="triggerPackageChanged"
        :packages="packages" :currentPackage="currentPackage" @quantityChanged="triggerQuantityChange"></WellsAddToCart>
      <KaaliAddToCart v-if="type === 'kaali'" :minQuantity="getMinPurchaseQuantity(minQuantity, maxQuantity)"
        :maxQuantity="getMaxPurchaseQuantity(maxQuantity)" :isLoading="isLoading"></KaaliAddToCart>
      <input type="hidden" name="action" value="add_to_cart" />
      <input v-if="variationId" type="hidden" name="variation_id" :value="variationId" />
      <input type="hidden" name="product_id" :value="id" />
    </form>
    <KaaliSuccess v-if="showSuccessMessage" :message="translations.product_added_to_cart"></KaaliSuccess>
    <KaaliError v-if="showErrorMessage" :message="errorMessage"></KaaliError>
    <button @click="showForm('rent')" type="button" v-if="isRentable" class="out-of-stock" data-html2canvas-ignore="">
      {{ translations.rentOutOfStock }}
    </button>
    <button @click="showForm('')" type="button" v-else-if="stockStatus != 'instock'" class="out-of-stock" data-html2canvas-ignore="">
      {{ translations.askForAvailability }}
    </button>
  </div>
</template>

<script>
import FragmentsRenderer from '@/externals/FragmentRenderer';
import WellsAddToCart from '@/components/general-ui/addtocarts/Wells.vue';
import KaaliAddToCart from '@/components/general-ui/addtocarts/Kaali.vue';
import KaaliSuccess from '@/components/general-ui/messages/success/Kaali.vue';
import KaaliError from '@/components/general-ui/messages/error/Kaali.vue';
import { Mutex } from 'async-mutex';

let lock = new Mutex();

export default {
  name: 'AddToCart',
  components: {
    WellsAddToCart,
    KaaliAddToCart,
    KaaliSuccess,
    KaaliError,
  },
  props: {
    name: String,
    sku: String,
    permalink: String,
    id: Number,
    variationId: Number,
    minQuantity: Number,
    maxQuantity: Number,
    soldIndividually: Boolean,
    measurementUnit: String,
    buyingStep: Number,
    stockStatus: String,
    packages: Array,
    currentPackage: String,
    isRentable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: ws_vue_store.config['add-to-cart'],
      isLoading: false,
      showSuccessMessage: false,
      showErrorMessage: false,
      changeAddToCartColor: false,
      errorMessage: '',
      translations: {
        product_added_to_cart: ws_vue_store.translations.product_added_to_cart,
        outOfStock: ws_vue_store.translations.out_of_stock,
        askForAvailability: ws_vue_store.translations.ask_for_availability,
        rentOutOfStock: ws_vue_store.translations.rent_out_of_stock,
      },
    };
  },
  methods: {
    triggerQuantityChange(qty) {
      this.$emit('quantityChanged', qty);
    },
    triggerPackageChanged() {
      this.$emit('packageChanged');
    },
    getMaxPurchaseQuantity(maxQuantity) {
      if (this.soldIndividually) {
        return 1;
      }
      return maxQuantity < 0 ? 9999999 : maxQuantity;
    },
    getMinPurchaseQuantity(minQuantity, maxQuantity) {
      return this.getMaxPurchaseQuantity(maxQuantity) === 0 ? 1 : minQuantity;
    },
    checkBuyingStep() {
      if (this.$refs.add_to_cart) {
        return this.$refs.add_to_cart.checkBuyingStep();
      }
      return false;
    },
    async addToCart(event) {
      if (this.checkBuyingStep()) {
        return; // Stop processing when not enough window is open
      };

      const self = this;
      this.isLoading = true;
      let release = await lock.acquire();

      let formData = new FormData(event.target);
      if (formData.get('quantity') && this.$refs.add_to_cart) {
        formData.set('quantity', this.$refs.add_to_cart.inputToNumber(formData.get('quantity')));
      }

      this.axios
        .post(
          wc_add_to_cart_params.wc_ajax_url
            .toString()
            .replace('%%endpoint%%', 'add_to_cart'),
          formData
        )
        .then((result) => {
          if (result.data.fragments) {
            self.isLoading = false;
            FragmentsRenderer.renderFragments(result.data.fragments);
            self.showSuccessMessage = true;
            self.changeAddToCartColor = true;
            setTimeout(function () {
              self.showSuccessMessage = false;
            }, 3000);
            self.$store.commit('setRecentlyAddedProduct', self.id);
          } else if (result.data.error) {
            self.getErrorMessages();
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          release();
        });
    },
    getErrorMessages() {
      const self = this;
      this.axios
        .get(ws_vue_store.ajax_url + '?action=get_cart_error_messages')
        .then((response) => {
          self.isLoading = false;
          if (response.data) {
            self.errorMessage = response.data[0];
            self.showErrorMessage = true;
            setTimeout(function () {
              self.showErrorMessage = false;
            }, 3000);
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        });
    },
    showForm(type) {
      const modalForm = document.querySelector((type == 'rent') ? '#rent-out-of-stock-form' : '#out-of-stock-form');
      const pageShadow = document.getElementById('js-page-shadow');
      const pageBody = document.querySelector('body');

      if (!modalForm)
        return;

      let subjectContent = this.name + ' - ' + this.sku;

      modalForm
        .querySelector('input[name="your-subject"]')
        .value = subjectContent;
      modalForm
        .querySelector('.js-out-of-stock-subject')
        .innerText = subjectContent;

      modalForm.classList.add('active');
      pageShadow.style.display = 'block';
      pageBody.style.overflowY = 'hidden';
    },
    getAddToCartColor() {
      if (
        ws_vue_store.change_add_to_cart_color == '1' &&
        (this.changeAddToCartColor ||
          ws_vue_store.cart_items.includes(this.id) ||
          this.$store.getters.getRecentlyAddedProducts.includes(this.id))
      ) {
        return ws_vue_store.add_to_cart_color;
      }
      return '';
    },
    isRentCategory() {
      return this.$store.getters.getRentCategory === '1';
    }
  },
};
</script>
